import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  HostBinding,
  QueryList,
} from '@angular/core';
import { GridColComponent } from '../col/grid-col.component';

@Component({
  selector: 'crm-grid',
  template: '<ng-content></ng-content>',
  styleUrls: ['./grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridComponent implements AfterContentInit {
  @HostBinding('attr.columns') columns = 12;

  @ContentChildren(GridColComponent, { read: GridColComponent }) cols: QueryList<GridColComponent>;

  ngAfterContentInit() {
    this.makeEqualColumns();
  }

  private makeEqualColumns(): void {
    const colsHaveSet = this.cols.some((col: GridColComponent) => col.cols != null);

    if (!colsHaveSet) {
      this.columns = this.cols.length;
    }
  }
}
